import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import { faqs } from "@/mocks/comics";

function FaqPage() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "faq-jsonld";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById("faq-jsonld");
      if (el) el.remove();
    };
  }, []);

  return (
    <Layout
      title="常见问题-会员特权阅读解答|土豪漫画网"
      description="土豪漫画网常见问题：关于尊享漫画、钻石漫画、贵族漫画、豪华漫画专属内容，会员特权阅读、豪华画质、多设备同步等常见疑问的详细解答。"
    >
      <section className="relative overflow-hidden pt-28 md:pt-36 pb-10">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-b from-primary-900/25 via-background-950 to-background-950"></div>
          <div className="absolute -left-20 top-8 h-72 w-72 rounded-full bg-primary-500/10 blur-3xl"></div>
        </div>
        <div className="relative mx-auto max-w-4xl px-4 md:px-6 text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/40 bg-primary-500/10 px-4 py-1.5 text-xs font-semibold tracking-widest text-primary-300">
            <i className="ri-question-line"></i>
            FAQ
          </span>
          <h1 className="mt-6 font-heading text-3xl font-black text-foreground-50 md:text-5xl">
            常见<span className="text-gold-grad">问题</span>
          </h1>
          <p className="mx-auto mt-4 max-w-2xl text-sm leading-7 text-foreground-400 md:text-base">
            关于尊享漫画、钻石漫画、贵族漫画、豪华漫画专属内容与会员特权阅读的常见疑问，答案都在这里。
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-4 md:px-6 pb-12 md:pb-16">
        <div className="space-y-3">
          {faqs.map((f, idx) => {
            const open = openIdx === idx;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-lg border transition ${
                  open ? "border-primary-500/40 bg-background-900" : "border-background-800 bg-background-900/40"
                }`}
              >
                <button
                  onClick={() => setOpenIdx(open ? null : idx)}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer"
                  aria-expanded={open}
                >
                  <span className="flex items-center gap-3">
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary-500/15 text-primary-400">
                      <i className="ri-question-line"></i>
                    </span>
                    <span className="font-heading text-base font-semibold text-foreground-100 md:text-lg">
                      {f.q}
                    </span>
                  </span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-background-700 text-primary-400 transition ${
                      open ? "rotate-180" : ""
                    }`}
                  >
                    <i className="ri-arrow-down-s-line"></i>
                  </span>
                </button>
                {open && (
                  <div className="border-t border-background-800 px-6 py-5 md:px-14">
                    <p className="text-sm leading-7 text-foreground-400">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-10 rounded-xl border border-background-800 bg-background-900/50 p-8 text-center">
          <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-primary-500 to-accent-500 text-xl text-foreground-950">
            <i className="ri-customer-service-2-line"></i>
          </span>
          <h2 className="mt-4 font-heading text-xl font-bold text-foreground-50">还有疑问？</h2>
          <p className="mx-auto mt-3 max-w-md text-sm leading-7 text-foreground-400">
            联系我们的专属客服团队，或在会员特权、关于我们页面了解更多。客服邮箱：service@tuhao-manga.example.com
          </p>
          <div className="mt-6 flex flex-col justify-center gap-3 sm:flex-row">
            <Link
              to="/vip"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-gradient-to-r from-primary-500 to-accent-500 px-6 py-3 text-sm font-semibold text-foreground-950 transition hover:from-primary-400 hover:to-accent-400 cursor-pointer"
            >
              <i className="ri-vip-diamond-fill"></i>
              开通会员特权
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-500/50 px-6 py-3 text-sm font-semibold text-primary-300 transition hover:bg-primary-500/10 cursor-pointer"
            >
              关于我们
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default FaqPage;